var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container"},[_c('h1',[_vm._v("AppSubmenuTitle")]),_c('table',[_c('tr',[_c('th',[_c('AppSubmenuTitle',{attrs:{"title":"Areas"}})],1)]),_c('tr',[_c('th',[_c('AppSubmenuTitle',{attrs:{"title":"Torres"}})],1)]),_c('tr',[_c('th',[_c('AppSubmenuTitle',{attrs:{"title":"Some submenu","icon":_vm.testIcon}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }